export function formatMs(num: number) {
  const totalSeconds = Math.floor(num / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes < 10 ? `0${minutes}` : `${minutes}`} : ${seconds < 10 ? `0${seconds}` : `${seconds}`}`
}

export function formatMs2Hour(ms: number) {
  const hours = Math.floor(ms / 3600000)
  const minutes = Math.floor((ms % 3600000) / 60000)
  const seconds = Math.floor(((ms % 3600000) % 60000) / 1000)

  // 格式化时、分、秒为两位数
  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minutes.toString().padStart(2, '0')
  const formattedSeconds = seconds.toString().padStart(2, '0')
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
}

// 判断基础数组是否相同
export function baseArrEqual(arr1: number[] | string[], arr2: number[] | string[]) {
  arr1.sort()
  arr2.sort()
  return JSON.stringify(arr1) === JSON.stringify(arr2)
}

export function containsArray(a: any[], b: any[]) {
  // 创建一个映射来跟踪数组a中每个元素的数量
  let countMap: any = {}
  for (let i = 0; i < a.length; i++) {
    if (countMap[a[i]]) {
      countMap[a[i]]++
    } else {
      countMap[a[i]] = 1
    }
  }

  // 检查数组b中的每个元素是否在数组a中，并且数量足够
  return b.every((item) => {
    if (countMap[item]) {
      countMap[item]--
      return true
    } else {
      return false
    }
  })
}

// 格式化数字（加逗号）
export function formatNumberWithCommas(num: number) {
  if (Number.isNaN(num)) return '0'
  // 首先确保我们有一个字符串
  let str = String(num)

  // 如果字符串包含小数点，我们需要分别处理整数部分和小数部分
  const parts = str.split('.')
  let integerPart = parts[0]
  let decimalPart = parts.length > 1 ? '.' + parts[1] : ''

  // 从右边开始，每三位添加一个逗号
  let formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  // 将整数部分和小数部分合并回一个字符串
  return formattedIntegerPart + decimalPart
}

// 格式化数字（尾部为万）
export function formatNumberWithWan(num: number) {
  if (num >= 1e8) {
    // 如果数字大于等于1亿
    return (num / 1e8).toFixed(2).replace(/\.00$/, '') + '亿'
  } else if (num >= 1e4) {
    // 如果数字大于等于1万
    return (num / 1e4).toFixed(2).replace(/\.00$/, '') + '万'
  }
  return num.toString() // 小于1万的数字保持原样
}

// 处理数字
export function formatNumber(num?: number, accuracy: number = 0) {
  if (typeof num !== 'number') return
  return Number(num.toFixed(accuracy))
}

export function randomOne<T>(list: T[]) {
  return list[Math.floor(Math.random() * list.length)]
}

// 随机排序数组
export function shuffleArray<T>(arr: T[]) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[arr[i], arr[j]] = [arr[j], arr[i]]
  }
}
